import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import Typography from '@segment/matcha/components/Typography'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

const copy = {
  heading: `We can't wait to see what you build`,
}

const button = {
  text: `Sign up and start building`,
  url: `https://www.twilio.com/try-twilio/?utm_source=segment&utm_medium=referral&utm_campaign=segment_better_together&utm_content=twilio_landing`,
}

const Signup = () => {
  return (
    <Wrapper>
      <StyledSectionBase variant="centered">
        <StyledTypography variant="h2">{copy.heading}</StyledTypography>
        <Button color="primary" variant="filled" size="large" href={button.url} iconEnd={ChevronRightIcon}>
          {button.text}
        </Button>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`

const StyledTypography = styled(Typography)`
  text-align: center;
`

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 96px;
    padding-bottom: 120px;
    gap: 26px;
  }
`

export default Signup
